import { render, staticRenderFns } from "./RecordNameVoteList.vue?vue&type=template&id=a5c9ba9a&scoped=true"
import script from "./RecordNameVoteList.vue?vue&type=script&lang=js"
export * from "./RecordNameVoteList.vue?vue&type=script&lang=js"
import style0 from "./RecordNameVoteList.vue?vue&type=style&index=0&id=a5c9ba9a&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5c9ba9a",
  null
  
)

export default component.exports